export default function SellerConcerns() {
  const concerns = [
    'How much is my home really worth?',
    'Is now the right time to sell?',
    'What should I repair or improve before listing?',
    'How long could the selling process take?',
    'How can I attract serious buyers?',
    'How do I avoid accepting less than the property is worth?',
    'What happens after I receive an offer?',
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100/70">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <h2 className="font-heading text-foreground-900 text-2xl md:text-3xl lg:text-4xl mb-4">
            Selling Your Home Is a Major Decision
          </h2>
          <p className="text-foreground-600 font-body text-base md:text-lg max-w-[700px] mx-auto">
            It's natural to have questions. Nearly every homeowner asks the same
            things before they sell — and Carol is here to answer every one of
            them with clear, honest guidance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-[850px] mx-auto mb-12">
          {concerns.map((concern, i) => (
            <div
              key={i}
              className="flex items-start gap-3 bg-background-50 rounded-lg p-4 border border-background-200/70"
            >
              <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center mt-0.5">
                <i className="ri-question-line text-primary-500 text-lg" />
              </div>
              <p className="text-foreground-700 font-body text-sm md:text-base">
                {concern}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center max-w-[700px] mx-auto">
          <p className="text-foreground-600 font-body text-base leading-relaxed">
            You don't need to figure this out alone. Carol has guided many
            homeowners through these exact questions — and she will take the
            time to understand your situation before offering any advice.
            Everything starts with a simple, no-pressure conversation.
          </p>
        </div>
      </div>
    </section>
  );
}